<template>
<div class="chapter">
<div class="inner_page">
<div id="ack">
<br/><br/><br/><br/><br/><br/><br/>
<p style="text-align: center;">"I went for a walk, just baby and me. It was a glorious sunny</p>
<p style="text-align: center;">day – blue sky, warm sun. Went up the Clyro road, then turned round and looked at little Hay, shut in by its mountains.</p>
<p style="text-align: center;">When one goes outside the house, everything seems to fall into its true proportions."</p>
<p style="text-align: center;">From my mother’s diary, 7 February 1953</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0003.vue?23e17798